/** Identifies the supported game implementations. */
export enum GameKind {
  Challenge = 'challenge',
  Racing = 'racing',
  Kwiz = 'kwiz',
  Adventure = 'adventure',
}
